import { fromJS, Map as ImmutableMap } from 'immutable';
import * as LocalStorageKeys from 'automation-ui-canvas/constants/LocalStorageKeys';
const LOCAL_STORAGE_KEY = 'workflows';
// on pull from local storage we need to recombine the "canvas-height" object
// back into the rest of the retrieved storage.
// https://git.hubteam.com/HubSpot/AutomationTeam/issues/4014
export function getWorkflowsLocalStorage() {
  try {
    const rawData = fromJS(JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {});
    return combineLocalStorageObjects(rawData);
    // eslint-disable-next-line no-empty
  } catch (_unused) {}
  const blankMap = ImmutableMap();
  return blankMap;
}

// on store to localStorage split out the canvas-heights into its own object
// to setup reducing data size
// https://git.hubteam.com/HubSpot/AutomationTeam/issues/4014
export function setWorkflowsLocalStorage(rawData) {
  const splitData = splitLocalStorageObjects(rawData);
  const data = splitData.get('data');
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(fromJS(data)));
    return data;
    // eslint-disable-next-line no-empty
  } catch (error) {}

  // our setItem failed above. Return a blank object to avoid erroring
  const blankMap = ImmutableMap();
  return blankMap;
}
function combineLocalStorageObjects(splitData) {
  // Filter out legacy canvas node height cache
  if (splitData && splitData.has(LocalStorageKeys.CANVAS_NODE_HEIGHTS)) {
    const preCombinedData = splitData.remove(LocalStorageKeys.CANVAS_NODE_HEIGHTS);
    return preCombinedData;
  }
  return splitData;
}
function splitLocalStorageObjects(combinedData) {
  // Filter out legacy canvas node height cache
  const data = ImmutableMap(combinedData.entrySeq().filter(([key]) => !isACanvasHeightKey(key)));
  return ImmutableMap({
    data
  });
}
function isACanvasHeightKey(key) {
  const targetComparisonLength = LocalStorageKeys.CANVAS_NODE_HEIGHTS.length;
  return key.length > targetComparisonLength && key.substring(0, targetComparisonLength) === LocalStorageKeys.CANVAS_NODE_HEIGHTS;
}